import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header__margin" }
const _hoisted_2 = ["src", "height", "width"]
const _hoisted_3 = ["src", "height", "width"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "header__open-menu-icon",
  width: "26",
  height: "26",
  viewbox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "3",
    cy: "3",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "13",
    cy: "3",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "23",
    cy: "3",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "3",
    cy: "13",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "13",
    cy: "13",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "23",
    cy: "13",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "3",
    cy: "23",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "13",
    cy: "23",
    r: "3",
    fill: "#1C212D"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "23",
    cy: "23",
    r: "3",
    fill: "#1C212D"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "nav__dark" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "nav__teal" }, null, -1)
const _hoisted_8 = { class: "nav__grid" }
const _hoisted_9 = ["src", "height", "width"]
const _hoisted_10 = { class: "nav__social-media" }
const _hoisted_11 = { class: "nav__menu-container" }
const _hoisted_12 = { class: "nav__menu" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "nav__close-container" }
const _hoisted_15 = { class: "nav__close-margin" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewbox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 1L1 21",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L21 21",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass(["header", _ctx.headerClasses])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.logoLight || _ctx.logoDark)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/",
              class: _normalizeClass(_ctx.logoClasses)
            }, {
              default: _withCtx(() => [
                (_ctx.logoLight)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "header__logo header__logo--light",
                      src: _ctx.logoLight.filename,
                      height: _ctx.logoLight.height,
                      width: _ctx.logoLight.width
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (_ctx.logoDark)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "header__logo header__logo--dark",
                      src: _ctx.logoDark.filename,
                      height: _ctx.logoLight.height,
                      width: _ctx.logoLight.width
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["header__open-menu", _ctx.openMenuClasses]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleNav()))
        }, _hoisted_5, 2)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["nav", { 'nav--open': _ctx.isNavOpen }])
    }, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "nav__logo nav__pop-in",
          style: _normalizeStyle(_ctx.pop(0))
        }, [
          (_ctx.logoLight)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "header__logo",
                    src: _ctx.logoLight.filename,
                    height: _ctx.logoLight.height,
                    width: _ctx.logoLight.width
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings?.socialMedia, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item._uid,
              class: "nav__social-media-item nav__pop-in",
              style: _normalizeStyle(_ctx.pop(idx))
            }, [
              _createVNode(_component_router_link, {
                to: _ctx.resolveLink(() => item.link)?.url,
                target: item.target
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "target"])
            ], 4))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings?.navigation, (item, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item._uid,
                style: _normalizeStyle(_ctx.pop(idx)),
                class: _normalizeClass({
              'nav__menu-item nav__pop-in': item.component === 'MenuItem',
              'nav__menu-item--active': _ctx.route.pathname === _ctx.resolveLink(() => item.link)?.url,
              'nav__menu-item-divider nav__pop-in': item.component === 'MenuDivider',
            })
              }, [
                (item.component === 'MenuItem')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: _ctx.resolveLink(() => item.link)?.url,
                      target: item.target
                    }, {
                      default: _withCtx(() => [
                        (item.pictogram?.id)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.imageFit(item.pictogram, { width: 24, height: 24 }).filename,
                              width: "24",
                              height: "24"
                            }, null, 8, _hoisted_13))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "target"]))
                  : _createCommentVNode("", true)
              ], 6))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "nav__close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
          }, _hoisted_17)
        ])
      ])
    ], 2)
  ], 64))
}